import React, { useState } from 'react'
import { useLocation, Link } from 'react-router-dom';
import PopupLogout from '../Popup-logout/PopupLogout';
import Profile_pic from '../../assets/images/profile_pic.svg';
import Right_arrow from '../../assets/images/rightArrow.svg';
import PopupDeleteAccount from '../popup-delete-account/popupDeleteAccount';

export default function SideMenu() {
    const email = localStorage.getItem('email');
    const userData = JSON.parse(localStorage.getItem('userData'));
    const location = useLocation();
    const currentPage = location.pathname;

    const [isLogoutPopupVisible, setIsLogoutPopupVisible] = useState(false); // state to control the visibility of the logout popup
    const [isDeleteAccountPopupVisible, setIsDeleteAccountPopupVisible] = useState(false);

    const handleLogoutClick = () => {
        setIsLogoutPopupVisible(true);
        document.body.style.overflow = 'hidden';
    };

    const handleDleteAccountClick = () => {
        setIsDeleteAccountPopupVisible(true);
        document.body.style.overflow = 'hidden';
    };

    const handleLogoutPopupClose = () => {
        setIsLogoutPopupVisible(false);
        document.body.style.overflow = 'unset';
    };
    const handleDeleteAccountPopupClose = () => {
        setIsDeleteAccountPopupVisible(false);
        document.body.style.overflow = 'unset';
    };

    const addDefaultSrc = (ev) => {
        ev.target.src = Profile_pic;
    };




    return (
        <>
            <div className='side-menu-holder'>
                <div className='user-info'>
                    <div className='profile-pic-holder'>
                        <img className='profile-pic' onError={addDefaultSrc} src={userData.image_url} alt='profile-pic' />
                    </div>
                    <div className='user-name'>
                        <span>{userData.firstName}</span>
                        <span className='last-name'>{userData.lastName}</span>
                    </div>
                    <span className='email'>{email}</span>
                </div>
                <div className='content-holder'>
                    <Link to="/profile-settings" className={`content-with-arrow ${currentPage === '/profile-settings' ? 'active' : ''}`}>
                        <p className='content-text'>My profile</p>
                        <img className="right-arrow" src={Right_arrow} alt="rightArrow" />
                    </Link>

                    <Link to="/favourits" className={`content-with-arrow ${currentPage === '/favourits' ? 'active' : ''}`}>
                        <p className='content-text'>Favorites</p>
                        <img className="right-arrow" src={Right_arrow} alt="rightArrow" />
                    </Link>
                    <div className={`content-with-arrow ${currentPage === '/logout' || isLogoutPopupVisible ? 'active' : ''}`} onClick={handleLogoutClick}>
                        <p className='content-text'>Logout</p>
                        <img className="right-arrow" src={Right_arrow} alt="rightArrow" />
                    </div>


                    <div className={`content-with-arrow ${currentPage === '/delete-account' || isDeleteAccountPopupVisible ? 'active' : ''}`} onClick={handleDleteAccountClick}>
                        <p className='content-text'>Delete account</p>
                        <img className="right-arrow" src={Right_arrow} alt="rightArrow" />

                    </div>
                </div>

            </div>
            {isLogoutPopupVisible && <PopupLogout onClose={handleLogoutPopupClose} />}
            {isDeleteAccountPopupVisible && <PopupDeleteAccount onClose={handleDeleteAccountPopupClose} />}
        </>
    )
}
